import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["selectedTab", "setTab", "path"];
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { getI18nText } from 'pricing-pages-lib/utils/languageUtils';
import { createToObject } from 'pricing-pages-lib/utils/queryParamUtils';
import { orderedTabs } from 'pricing-pages-ui/constants/routing/Tabs';
import RouterTab from 'ui-addon-react-router-dom/RouterTab';
import RouterTabs from 'ui-addon-react-router-dom/RouterTabs';
import { trackClickedLink } from '../../../utils/tracking/trackingEventUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const SegmentedTabs = _ref => {
  let {
      selectedTab,
      setTab = () => {},
      path = ''
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const renderTitleText = tabId => rest.use && rest.use === 'enclosed' ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: `pricingPage.tabs.enclosed.${tabId}`
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: `pricingPage.tabs.${tabId}`
  });
  const handleTabClick = tab => {
    trackClickedLink({
      name: 'segmented-tab',
      value: getI18nText(`pricingPage.tabs.${tab}`, {
        locale: 'en-us'
      }),
      type: 'internal',
      tab,
      url: `${path}/${tab}`
    });
    setTab(tab);
  };
  return /*#__PURE__*/_jsx(Flex, {
    justifyContent: "center",
    children: /*#__PURE__*/_jsx(RouterTabs, Object.assign({}, rest, {
      inlineSize: "560px",
      fill: true,
      children: orderedTabs.map(tabId => {
        return /*#__PURE__*/_jsx(RouterTab, {
          active: selectedTab === tabId,
          title: renderTitleText(tabId),
          to: createToObject(`${path}/${tabId}`),
          onClick: () => handleTabClick(tabId),
          "data-selenium-id": `segmented-tab-${tabId}`,
          marginBlockStart: "0 !important"
        }, tabId);
      })
    }))
  });
};
export default SegmentedTabs;